/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Patient API
 * API for Patient
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PutNameRequestBodyTypename = "PutNameRequestBody" as const;

/**
 *
 * @export
 * @interface PutNameRequestBody
 */
export interface PutNameRequestBody {
  /**
   *
   * @type {string}
   * @memberof PutNameRequestBody
   */
  name?: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PutNameRequestBody
   */
  readonly __typename?: string;
}

export function PutNameRequestBodyFromJSON(json: any): PutNameRequestBody {
  return PutNameRequestBodyFromJSONTyped(json, false);
}

export function PutNameRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): PutNameRequestBody {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PutNameRequestBodyTypename,

    name: !exists(json, "name") ? undefined : json["name"],
  };
}

export function PutNameRequestBodyToJSON(object?: PutNameRequestBody | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    name: value.name,
  };
}
